import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface FilterHeaderProps {
  selectedCount: number;
  isAllSelected: boolean;
  onSelectAll: () => void;
  onClearAll: () => void;
}

export function FilterHeader({ selectedCount, isAllSelected, onSelectAll, onClearAll }: FilterHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between p-2 border-b">
      <span className="text-sm font-medium">
        {selectedCount} {t('common.selected')}
      </span>
      <div className="flex gap-1">
        <Button variant="ghost" size="sm" onClick={onSelectAll} disabled={isAllSelected} className="h-7 px-2 text-xs">
          {t('gen.select.all.label')}
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearAll}
          disabled={selectedCount === 0}
          className="h-7 px-2 text-xs">
          {t('common.clear')}
        </Button>
      </div>
    </div>
  );
}
